import {
  getPatients,
  createDummyData,
  deleteDummyAppointments,
} from "../../../../services/api-clinic";
import { getAppointmentsForClinic } from "../../../../services/api-appointment";
import { TSession } from "../../../../utils/types";

export const initializeClinicDataIfNeeded = async (
  session: TSession,
): Promise<void> => {
  console.log("🔍 Initializing clinic data if needed...");
  if (!session) return;

  if (!session.clinicId) {
    console.error(
      "❗ Clinic ID is not set in session. Cannot initialize data.",
    );
    return;
  }

  try {
    const [patients, appointments] = await Promise.all([
      getPatients(session, undefined, undefined, true),
      getAppointmentsForClinic(session, true),
    ]);

    const today = new Date();
    const hasPatients = patients.length > 0;
    const futureAppointments = appointments.filter(
      (appt) => new Date(appt.date) >= today,
    );

    const hasFutureAppointments = futureAppointments.length > 0;
    const hasAppointments = appointments.length > 0;

    if (!hasPatients || !hasAppointments) {
      console.log("❗ No patients or appointments — creating dummy data...");
      await createDummyData(session, session.clinicId, {
        create_patients: true,
        create_appointments: true,
      });
    } else if (hasAppointments && !hasFutureAppointments) {
      console.log(
        "⚠️ Appointments exist but none in the future — resetting...",
      );
      await deleteDummyAppointments(session, session.clinicId);
      await createDummyData(session, session.clinicId, {
        create_patients: false,
        create_appointments: true,
      });
    } else {
      console.log("✅ Clinic has valid patients and future appointments.");
    }
  } catch (err) {
    console.error("Error during dummy data setup:", err);
  }
};
